import React, { useEffect, useState }  from 'react';
import DatePicker from "react-horizontal-datepicker";
import { styled } from '@mui/styles';
import { useTheme } from '@emotion/react'
import { Grid, useMediaQuery } from "@mui/material";
import { useRecoilState, useRecoilValue, useResetRecoilState } from "recoil";
import { daysAvailableState, hoursAvailableState, loadingDaysCalendarState, professionalsMatchCovenantState, professionalsNoMatchCovenantState } from "../../state/atoms";
import { dayDefaultAvailableState } from "./state/atoms";
import { markDaysAvailable } from "./helpers/markDaysAvailable";
import { translateCalendarHorizontal } from "./helpers/translateCalendar";
import { setActiveDay } from "./helpers/setActiveDay";
import CalendarHorizontalSkeleton from "../../../shared/components/skeletons/CalendarHorizontalSkeleton";
import useSearchHours from "src/SearchHours/hooks/useSearchHours";

const ContainerCalendarCustom = styled((props) => <Grid {...props} />)(
    ({ theme }) => ({
        display: 'none',
        [theme.breakpoints.down('md')]: {
            display: 'block',
            padding: '16px 12px',
            boxShadow: '0 10px 15px -3px rgb(0 0 0 / 10%), 0 4px 6px -4px rgb(0 0 0 / 10%)'
        },
        marginBottom: 10,
        position: 'fixed',
        width: '100vw',
        top: 65,
        zIndex: 10,
    }),
);

const CalendarHorizontal = () => {
    const theme = useTheme();

    const [isMounted, setIsMounted] = useState(false);
    const daysAvailable = useRecoilValue(daysAvailableState);
    const [dayDefaultAvailable, setDayDefaultAvailable] = useRecoilState(dayDefaultAvailableState);
    const resetHoursAvailable =  useResetRecoilState(hoursAvailableState)
    const resetHrofessionalsMatchCovenant =  useResetRecoilState(professionalsMatchCovenantState)
    const resetHrofessionalsNoMatchCovenant =  useResetRecoilState(professionalsNoMatchCovenantState)
    const isMediaScreen = useMediaQuery(theme.breakpoints.down("lg"));

    const { loadingDaysAvailable, loading } = useSearchHours();
    const loadingDaysCalendar = useRecoilValue(loadingDaysCalendarState);


    useEffect(() => {
        setIsMounted(true);

        return () => {
            setIsMounted(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (dayDefaultAvailable) {
            setActiveDay(dayDefaultAvailable);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dayDefaultAvailable])

    useEffect(() => {
        translateCalendarHorizontal();
        if (isMediaScreen && daysAvailable.length > 0 && !loadingDaysAvailable) {
            translateCalendarHorizontal();
            setIsMounted(false);
            markDaysAvailable(daysAvailable)
            setActiveDay(dayDefaultAvailable);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isMediaScreen, daysAvailable, loadingDaysAvailable])

    const selectedDay = val => {
        if (isMounted || !isMediaScreen) return;

        resetHoursAvailable();
        resetHrofessionalsMatchCovenant();
        resetHrofessionalsNoMatchCovenant();
        setActiveDay(val)
        setDayDefaultAvailable(val)
    };

    return (
        <ContainerCalendarCustom theme={theme} item md={12} xs={12} mb={2}>
            {
                loadingDaysCalendar || loading ? (<CalendarHorizontalSkeleton />) :
                    <DatePicker
                        getSelectedDay={selectedDay}
                        endDate={1000}
                        selectDate={dayDefaultAvailable}
                        labelFormat={"MMMM yyyy"}
                        color={theme.palette.primary.main}
                    />
            }
        </ContainerCalendarCustom>
    )
}

export default CalendarHorizontal
